import { jsx } from "react/jsx-runtime";
import { useState } from "react";
import { M as MarketplaceContext } from "./index-Jj5pKhlE.js";
import { a as getDefaultFilters } from "./marketplace-BNakCyBo.js";
const MarketplaceProvider = ({ children, defaultFilters = [] }) => {
  const [filters, setFilters] = useState(getDefaultFilters(defaultFilters));
  return /* @__PURE__ */ jsx(
    MarketplaceContext.Provider,
    {
      value: {
        filters,
        setFilters
      },
      children
    }
  );
};
export {
  MarketplaceProvider as M
};
//# sourceMappingURL=MarketplaceProvider-CrLlhe6h.js.map
